<script setup>
import Message from "primevue/message";
import { useNotificationsStore } from "@/stores/notifications";

const notificationsStore = useNotificationsStore();

function addNotification() {
  notificationsStore.addNotifications("Hello");
}
</script>
<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Alert",
};
</script>
<template>
  <Button @click="addNotification" label="add a notification" />
  <Message v-for="(message, i) in notificationsStore.notifications" :key="i">{{
    message
  }}</Message>
</template>
